import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';
import PortalPageShell, { PortalEmpty, PortalLoading } from '../PortalPageShell';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

export default function PortalStudentExams() {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/portal/student/exams');
        if (!cancelled) setExams(res.data?.data ?? []);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <PortalPageShell title="Exam Schedule" description="Published datesheets">
      {loading ? <PortalLoading /> : null}
      {!loading && exams.length === 0 ? <PortalEmpty message="No published exam schedules." /> : null}
      <div className="space-y-3">
        {exams.map((exam) => (
          <Card key={exam.id}>
            <CardHeader>
              <CardTitle className="text-base">{exam.name}</CardTitle>
              <p className="text-sm text-muted-foreground">
                {exam.start_date} – {exam.end_date}
              </p>
            </CardHeader>
            {exam.datesheet?.schedule_json ? (
              <CardContent>
                <pre className="text-xs whitespace-pre-wrap bg-muted p-3 rounded-md overflow-x-auto">
                  {typeof exam.datesheet.schedule_json === 'string'
                    ? exam.datesheet.schedule_json
                    : JSON.stringify(exam.datesheet.schedule_json, null, 2)}
                </pre>
              </CardContent>
            ) : null}
          </Card>
        ))}
      </div>
    </PortalPageShell>
  );
}
